import { USER_DATA, LOGOUT } from '../constants'
import { appLoading, appMessage } from './appActions'

import { auth, DB } from '../firebase'



export const loginWithEmailPassword = ( email, password ) => async(dispatch) => {
  dispatch(appLoading(true))
  await auth.signInAndRetrieveDataWithEmailAndPassword(email, password)
    .then( async response => {
      const { uid } = response.user
      let userDetail = await getUserDetail(uid)
      if( userDetail.type ) {
        userDetail = { ...userDetail, id: uid }
        
        dispatch({ type: USER_DATA, payload: userDetail })
        dispatch(appMessage(''))
      } else {
        dispatch(appMessage('Niepoprawny typ użytkownika; skontaktuj się z obsługą aplikacji.'))
      }
    })
    .catch( err => {
      dispatch(appMessage('Niepoprawne dane logowania' ))
    })
}

export const getUserDetail = userId => {
  return DB.collection('users').doc(userId).get()
          .then(r => r.data())
}

export const logOut = () => {
  return { type: LOGOUT }
}




// WEBPACK FOOTER //
// ./src/actions/loginActions.js